import ApiClient from './apiClient';
import { Http } from 'vue-resource/types/vue_resource';
import { ApiConfig } from '@/configs/apiConfig';

export default class RestApiClient implements ApiClient {

    constructor(
        private http: Http,
        private config: ApiConfig,
    ) { }

    public test(): PromiseLike<number> {
        const url = this.createUrl("test");
        return this.http.get(url).then(x => Number(x.data));
    }

    private createUrl(relativePath: string): string {
        if (relativePath[0] !== '/') {
            relativePath = '/' + relativePath;
        }
        return `${this.config.baseUrl}/api${relativePath}`;
    }
}
